import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NewLenderAudit from '../audit/NewLenderAudit';
import AuditJobs from '../audit/AuditJobs';
import CompletedAudits from '../audit/CompletedAudits';
import ScoreCard from '../audit/ScoreCard';
import Login from '../utils/Login';
import Dashboard from '../dashboard/Dashboard';
const Routes = () => {
    return (
        <Switch>
            
            <Route path="/login" component={Login} />
            <Route path="/" exact component={Dashboard} />
            <Route path="/jobs/all" component={AuditJobs} />

            <Route path="/jobs/audit/scorecard/:id" component={ScoreCard} />
            <Route path="/jobs/audit/:id" component={NewLenderAudit} />
            <Route path="/view-all-audits" component={CompletedAudits} />
            
            
        </Switch>
    );
};

export default Routes;